import $ from 'jquery'
import ajaxLoadMoreProducts from '../libraries/ajax-load-more-products.js'

function toggleMobileCategories () {
  const toggler = document.querySelector('[data-category-toggler]')
  const filters = document.querySelector('[data-mobile-filters]')

  toggler.addEventListener('click', function (event) {
    event.preventDefault()
    filters.classList.toggle('hidden')
    toggler.querySelector('.baby-triangle').classList.toggle('rotate-180')
    return false
  })
}

$(document).ready(function () {
  toggleMobileCategories()

  // Products load more
  ajaxLoadMoreProducts()

  // Product  Categories
  $('span.filter').on('click', function () {
    const value = $(this).attr('data-value')
    composeUrl('product_cat', value)
  })

  // Collections
  $('select.collections').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('col', value)
  })

  // Finishes
  $('select.finishes').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('finish', value)
  })

  // Designers
  $('select.designers').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('des', value)
  })

  // Is configurable
  $('span.is-configurable').on('click', function () {
    const value = !$(this).hasClass('selected')
    composeUrl('configurable', value)
  })

  // Pagination
  $('span.page-number').on('click', function () {
    const value = $(this).attr('data-value')
    composeUrl('pg', value)
  })
})

function composeUrl (key, value) {
  const url = new URL(document.location.href)

  // if primary filter change, remove secondary filters
  if (key == 'product_cat' && url.searchParams.has(key)) {
    // Col
    if (url.searchParams.has('col')) {
      url.searchParams.delete('col')
    }

    // Finish
    if (url.searchParams.has('finish')) {
      url.searchParams.delete('finish')
    }

    // Des
    if (url.searchParams.has('des')) {
      url.searchParams.delete('des')
    }

    // Configurable
    if (url.searchParams.has('configurable')) {
      url.searchParams.delete('configurable')
    }

    // Pagination
    if (url.searchParams.has('pg')) {
      url.searchParams.delete('pg')
    }
  }

  // Remove element if is already present and values is empty
  if (url.searchParams.has(key) && value === '') {
    url.searchParams.delete(key)
  } else {
    url.searchParams.set(key, value)
  }

  // Check for configurable param
  if (key === 'configurable' && value === false) {
    url.searchParams.delete(key)
  }

  // Check pagination offsets
  if (url.searchParams.has('pg')) {
    const max = $('input[name="max-pages"]').val() ?? 1
    if (parseInt(url.searchParams.get('pg')) > parseInt(max)) {
      url.searchParams.delete('pg')
    }
  }

  // Remove pagination if another filter is entered
  if (key !== 'pg' && url.searchParams.has('pg')) {
    url.searchParams.delete('pg')
  }

  // Redirect
  document.location = url.href
}
